import * as React from 'react';
import { Edit, EditProps, NumberInput, SimpleForm } from 'react-admin';

export const MarathonWeightingEdit = (props: EditProps): React.ReactElement => {
	// const refresh = useRefresh();

	return (
		<Edit {...props} mutationMode="pessimistic">
			{/*	redirect={(*/}
			{/*	resource?: string,*/}
			{/*	id?: any,*/}
			{/*	data?: any,*/}
			{/*	state?: object*/}
			{/*) => {*/}
			{/*	refresh();*/}

			{/*	return `events/${data.eventId}/show/product-items`;*/}
			{/*}}*/}
			<SimpleForm>
				<NumberInput label="WEIGHT" source="weight"/>
				<NumberInput label="MARATHON_DAY_NUMBER" source="marathonDayNumber"/>
				{/*<Labeled label="PURCHASED"><BooleanField label="PURCHASED" source="purchased"/></Labeled>*/}
				{/*<Labeled label="TOTAL_PURCHASED_SUM"><NumberField label="TOTAL_PURCHASED_SUM"*/}
				{/*                                                  source="totalPurchasedSum"/></Labeled>*/}
				{/*<Labeled label="NUMBER_OF_PURCHASES"><NumberField label="NUMBER_OF_PURCHASES"*/}
				{/*                                                  source="numberOfPurchases"/></Labeled>*/}
			</SimpleForm>
		</Edit>
	);
};
